import { useMemo } from "react";
import Text from "./Text";
import { StyleProp, StyleSheet, TextStyle, View, ViewStyle } from "react-native";
import { useTheme } from "../hooks/use-theme";

type NotificationsCounterProps = {
    count: number;
    style?: StyleProp<ViewStyle>;
    textStyle?: StyleProp<TextStyle>;
};

const COUNTER_SIZE = 16;

const NotificationsCounter = ({ count, style, textStyle }: NotificationsCounterProps) => {
    const styles = useStyles();

    const isMaxCount = count > 9;

    return count > 0 ? (
        <View style={[styles.badgeStyle, isMaxCount && { width: COUNTER_SIZE * 1.3 }, style]}>
            <Text style={[styles.textStyle, textStyle]} allowFontScaling={false}>
                {!isMaxCount ? count : "9+"}
            </Text>
        </View>
    ) : null;
};

export default NotificationsCounter;

const useStyles = () => {
    const { colors } = useTheme();

    return useMemo(
        () =>
            StyleSheet.create({
                badgeStyle: {
                    position: "absolute",
                    backgroundColor: colors.secondary,
                    width: COUNTER_SIZE,
                    height: COUNTER_SIZE,
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: COUNTER_SIZE / 2.5,
                    overflow: "hidden",
                    top: 2,
                    right: -4,
                    zIndex: 10,
                },
                textStyle: {
                    fontFamily: "Inter-Bold",
                    position: "absolute",
                    color: colors.onSecondary,
                    fontSize: 11,
                },
            }),
        [colors.onSecondary, colors.secondary],
    );
};
